// Wraps the "Limited Edition Box Contains:" line (and its variations) at the
// top of a product's contents in span.totl-contents-heading, so it can be gold
// on every layout (see the product type block at the end of totl-beta.css).
// The contents come from metafields and rich text in several shapes - its own
// <p><strong>, the first line of a <br> list, or bare text - so the heading is
// found as the first text node and only wrapped when it ends with a colon.
(function () {
  var CONTAINERS = [
    '.totl-legend-detail__contents',
    '.tb-panel__contents',
    '.totl-bourbon-product-card__contents',
    '.totl-250__contents',
    '.totl-game-product__contents',
    '.totl-bundle-product-left__contents',
    '.totl-bundle-product-right__contents',
    '.totl-merch-product__contents',
    '.product_contains_paragraph:not(.shipping)',
    '.tlv-card__contents',
    '.tlv-intro__contents'
  ].join(',');

  function wrapHeading(container) {
    if (container.hasAttribute('data-totl-heading')) return;
    container.setAttribute('data-totl-heading', '');
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.replace(/[\s ]+$/, '');
      if (!text.trim()) continue;
      if (!/:$/.test(text)) return;
      if (node.parentNode.classList && node.parentNode.classList.contains('totl-contents-heading')) return;
      var span = document.createElement('span');
      span.className = 'totl-contents-heading';
      node.parentNode.insertBefore(span, node);
      span.appendChild(node);
      return;
    }
  }

  function run(root) {
    if (!root.querySelectorAll) return;
    if (root.matches && root.matches(CONTAINERS)) wrapHeading(root);
    root.querySelectorAll(CONTAINERS).forEach(wrapHeading);
  }

  function init() {
    run(document);
    // Panels and cards swapped in later (variant changes, carousels).
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
